<script>
    // @ts-nocheck
    import otherinfo from '../assets/pictures/other-information-service.svg'
    import {
        Typography,
        Button,
        CircularButton,
        Modal,
        Form,
        BackDrop,
        Spinner,
    } from '$lib/components/UI'
    import { onMount } from 'svelte'
    import { AddCircle, AddOutline } from '$lib/components/Icons'
    import { confImp as confImp_org } from '$lib/conf'
    import FormBoxContainer from '$lib/components/UI/FormBoxContainer.svelte'
    import DocumentField from '$lib/components/UI/DocumentField.svelte'
    import user from '$lib/stores/user'
    import { API_URL } from '$lib/conf'
    import { fade, scale, fly } from 'svelte/transition'
    import { clickOutside } from '$lib/utils'
    import provider from '$lib/stores/provider'
    import DocumentationField from '$lib/components/forms/DocumentationField.svelte'
    let mapCategory = {
        IVA: ['condicion_iva', 'condicion_imp_iva_ii'],
        Ganancias: ['condicion_ganancias', 'condicion_imp_ganancias_ii'],
        IIBB: ['condicion_iibb', 'condicion_imp_ingresos_ii'],
    }
    let confImp = structuredClone(confImp_org)
    const reducerFunc = (acc, [key, value]) => ({ ...acc, [key]: value })
    let providerData = null
    let dataForm = {}
    let pendingDocs = []
    let activeDocs = []
    function getData() {
        return user.fetch(`${API_URL}/documents/${user.currentAccount}`)
        .then(async (res) => {
            if (res.ok) {
                let ret = await res.json()
                pendingDocs = ret.pending
                activeDocs = ret.active
                return ret
            } else {
                throw new Error(`Error ${res.status}: ${res.statusText}`)
            }
        })
        .catch((res) => {
            console.error(res)
        })
    }
    let fetchData = getData()
    let fetchDoc = null
    let showDoc = false
    let showEditView = false
    let currentDocLink = null
    let currentTitleDoc = ''
    // let currentTipoImpuesto = "";
    let currentDocConfig = {}
    let isValidDocForm = false
    let blockSendButton = false

    function loadPDF() {
        fetchDoc = fetch(currentDocLink + '/base64')
            .then(async (r) => {
                let typeMime = r.headers.get('Content-Type')
                if (r.ok) {
                    return [await r.text(), typeMime]
                } else {
                    throw new Error('El archivo no existe o fue borrado.')
                }
            })
            .catch(async (e) => {
                throw new Error(await e.text())
            })
    }

    function categorizeDocs(arrayDocs) {
        let ret = {}
        let categories = ['IVA', 'Ganancias', 'IIBB']
        categories.forEach((category) => {
            ret[category] = arrayDocs.filter((doc) => doc.impuesto === category)
        })
        ret.general = arrayDocs.filter((doc) =>
            ['', 'general', 'General', null, undefined].includes(doc.impuesto)
        )
        ret.otros = arrayDocs.filter((doc) =>
            ['otros', 'Otros'].includes(doc.impuesto)
        )
        return ret
    }

    function sendData() {
        let data = Object.fromEntries(
            Object.entries(dataForm).filter(([_, v]) => {
                return 'files' in v && v.files.length > 0
            })
        )
        blockSendButton = true
        user.fetch(`${API_URL}/documents/${user.currentAccount}/`, {
            method: 'POST',
            body: JSON.stringify(data),
        })
        .then(async (r) => {
            blockSendButton = false
            showEditView = false
            fetchData = getData()
            if (r.ok && r.status == 200) {
                return await r.json()
            } else {
                throw new Error('Error al enviar el documento')
            }
        })
        .catch((_) => {
            blockSendButton = false
            return null
        })
    }
    provider.reload()

    function getRegexDocName(str) {
        return new RegExp(
            str
                .replace(/[áéíóúÁÉÍÓÚ\u00f1\u00d1]/g, '.')
                .replace(/[\(]/g, '\\(')
                .replace(/[\)]/g, '\\)')
                .replace(/\$\w+/g, '.+')
                .replace(/\s/g, '\\s')
        )
    }

    function buildMatchFunc({ type, impuesto = '', label }) {
        // console.log({type, impuesto, label})
        return (doc) =>
            doc.tipo_documentacion === type &&
            doc.impuesto === impuesto &&
            (/\$\w+/.test(label)
                ? getRegexDocName(label).test(doc.title)
                : label === doc.title)
    }

    $: providerData = $provider
        ? $provider.editable
            ? $provider.data
            : $provider.tmpData
        : {}

    $: allConfigurations = Object.fromEntries(
        Object.entries(confImp)
            .filter(([k]) => k !== 'general')
            .map((x) =>
                Object.entries(x[1]).map(([_id, conf]) => {
                    return { ...conf, _id }
                })
            )
            .reduce((a, b) => a.concat(b), [])
            .map((x) => [
                `${x.impuesto}.${x._id}.${x.type}`,
                { ...x, match: buildMatchFunc(x) },
            ])
            .concat(
                confImp.general.map((x) => [
                    `general.${x.name}`,
                    { ...x, match: buildMatchFunc(x) },
                ])
            )
            .concat(
                confImp.otros.map((x) => [
                    `otros.${x.name}`,
                    { ...x, match: buildMatchFunc(x) },
                ])
            )
    )

    $: avalibleConfiguration = Object.keys(mapCategory)
        .map((x) =>
            Object.keys(allConfigurations).filter((n) =>
                new RegExp(
                    `^${x}\\.${providerData[mapCategory[x][1]]}\\..+$`
                ).test(n)
            )
        )
        .reduce((a, b) => a.concat(b), [])
        .reduce(
            (a, b) => {
                return Object.fromEntries(
                    Object.entries(a).concat([[b, allConfigurations[b]]])
                )
            },
            Object.fromEntries(
                Object.entries(allConfigurations).filter(([k]) =>
                    /general/.test(k)
                )
            )
        )

    $: myDocs = [
        ...pendingDocs.map((x) => ({ ...x, active: false, pending: true })),
        ...activeDocs.map((x) => ({ ...x, active: true, pending: false })),
    ].map((x) => {
        return {
            ...x,
            id:
                Object.entries(avalibleConfiguration)
                    .find(([_, v]) => v.match(x))
                    ?.at(0) || null,
            // .map(([k]) => k)
        }
    })

    $: requiredDocs = Object.entries(avalibleConfiguration)
        .filter(
            ([key, value]) =>
                (!(value.optional || false) || value.required || false) &&
                !myDocs.map((d) => d.id).includes(key)
        )
        .reduce(reducerFunc, {})

    $: if ($user) {
        console.log({ $user })
        if ($user?.tipo_proveedor === 'siniestros') {
            confImp.general.push({
                // Forfumlario obligatorio para proveedores de siniestros
                title: 'Adjuntar Formulario F931 o Declaración de No empleados',
                label: 'Formulario F931 o Declaración de No empleados',
                type: '2',
                name: 'docu_otros_ii',
                inputs: ['files*'],
                required: true,
            })
            console.log('provider_siniestros')
            fetchData = getData()
        } else {
            confImp = structuredClone(confImp_org)
        }
    }
    // $: console.log({
    //     test: Object.entries(allConfigurations).map(([k, {match}])=>[k, myDocs.filter(d => match(d))]).reduce(reducerFunc, {}),
    //     allConfigurations,
    //     myDocs
    // });
</script>

<div style="width: 100%; padding: 25px 68px 68px 68px">
    <div
        style="min-height: calc(100vh - 70px); display: flex; position: relative; flex-direction: column"
    >
        {#await fetchData}
            <span
                style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
            >
                <Spinner />
            </span>
        {:then _}
            {@const actDocs = categorizeDocs(
                myDocs.filter((d) => d.active || false)
            )}
            {@const pndDocs = categorizeDocs(
                myDocs.filter((d) => d.pending || false)
            )}
            {@const categorizedReqDocs = ['Ganancias', 'IIBB', 'IVA', 'general']
                .map((category) => [
                    category,
                    Object.keys(requiredDocs).filter((k) =>
                        new RegExp(`^${category}\..+$`).test(k)
                    ),
                ])
                .map(([category, list]) => [
                    category,
                    list.concat(
                        Object.entries(avalibleConfiguration)
                            .filter(
                                ([k, v]) =>
                                    v.impuesto === category &&
                                    !myDocs.map((d) => d.id).includes(k)
                            )
                            .map(([k]) => k)
                    ),
                ])
                .reduce(
                    (acc, [k, v]) => ({
                        ...acc,
                        [k]: v
                            .map((x) => [x, allConfigurations[x]])
                            .reduce(reducerFunc, {}),
                    }),
                    {}
                )}
            <!-- <textarea cols="30" rows="15" disabled>{JSON.stringify({actDocs}, null, 4)}</textarea> -->
            <div in:fly={{ y: 50, delay: 250 }} class="section">
                <!-- {#if Object.values(categorizedReqDocs).reduce((a, b) => a + Object.keys(b).length, 0) > 0} -->
                {#if true}
                    <!-- <p>{JSON.stringify({categorizedReqDocs, len: Object.values(categorizedReqDocs).reduce((a, b) => a + Object.keys(b).length, 0)}, null, 4)}</p>  -->
                    <span>
                        <Typography type="h2" style="margin: 50px 0 11px 0"
                            >Documentación a Actualizar</Typography
                        >
                        <Typography
                            type="body"
                            style="margin: 2px 0 0 0"
                            color="grey-800"
                            >A continuación verá la documentación que puede
                            actualizar.</Typography
                        >
                    </span>
                    {#each Object.entries(categorizedReqDocs) as [category, docs]}
                        {#if Object.entries(docs).length > 0}
                            <FormBoxContainer
                                title={`${!['general', 'otros'].includes(category) ? 'Impuesto' : 'Documentación'} ${category}`}
                            >
                                {#each Object.entries(docs) as [id, conf]}
                                    <DocumentField
                                        title={conf.title}
                                        download={false}
                                        replace
                                        on:replace={(_) => {
                                            currentDocConfig = conf
                                            showEditView = true
                                        }}
                                        config={{
                                            replace: {
                                                label: 'Agregar',
                                                icon: AddCircle,
                                            },
                                        }}
                                    />
                                    <!-- <p>{id} {JSON.stringify(conf)}</p> -->
                                {/each}
                            </FormBoxContainer>
                        {/if}
                    {/each}
                    <FormBoxContainer title="Documentación adicional">
                        <DocumentField
                            title="Otra documentación"
                            download={false}
                            replace
                            on:replace={(_) => {
                                currentDocConfig =
                                    allConfigurations['otros.docu_otros_ii']
                                showEditView = true
                            }}
                            config={{
                                replace: { label: 'Agregar', icon: AddCircle },
                            }}
                        />
                    </FormBoxContainer>
                {/if}
            </div>

            <div in:fly={{ y: 50, delay: 500 }} class="section">
                {#if Object.values(actDocs).reduce((a, b) => a + b.length, 0) > 0}
                    <span>
                        <Typography type="h2" style="margin: 50px 0 11px 0"
                            >Documentación Activa</Typography
                        >
                        <Typography
                            type="body"
                            style="margin: 2px 0 0 0"
                            color="grey-800"
                            >A continuación verá la documentación aprobada.</Typography
                        >
                    </span>
                    {#each Object.entries(actDocs) as [category, docs]}
                        {#if docs.length > 0}
                            <FormBoxContainer
                                title={`${!['general', 'otros'].includes(category) ? 'Impuesto' : 'Documentacion'} ${category}`}
                            >
                                {#each docs as { title, link, id }}
                                    <!-- replace={!inPending(link, category)} -->
                                    <!-- replace={id && !myDocs.filter(d => d.pending).includes(id)} -->
                                    <DocumentField
                                        preview
                                        {title}
                                        replace={!pndDocs[category]?.some(
                                            (doc) => doc.title === title
                                        )}
                                        on:replace={(_) => {
                                            currentDocConfig =
                                                allConfigurations[id]
                                            showEditView = true
                                        }}
                                        on:preview={(_) => {
                                            currentDocLink = link
                                            currentTitleDoc = title
                                            loadPDF()
                                            showDoc = true
                                        }}
                                        on:download={(_) => {
                                            window.open(link, '_blank')
                                        }}
                                    />
                                {/each}
                                {@const optionals = Object.entries(
                                    avalibleConfiguration
                                )
                                    .filter(
                                        ([k, v]) =>
                                            category === v.impuesto && v.multi
                                    )
                                    .reduce(
                                        (a, [k, v]) => ({ ...a, [k]: v }),
                                        {}
                                    )}
                                <!-- <p>{JSON.stringify(optionals, null, 4)}</p> -->
                                {#if Object.values(optionals).length > 0}
                                    <span
                                        style="display: flex; flex-direction: row; justify-content: flex-end; padding: 14px"
                                    >
                                        {#each Object.entries(optionals) as [id, { title }]}
                                            <Button
                                                size="small"
                                                label={`Agregar ${title}`}
                                                style="padding: 5px 8px"
                                                on:click={(_) => {
                                                    currentDocConfig =
                                                        allConfigurations[id]
                                                    showEditView = true
                                                    console.log(
                                                        allConfigurations,
                                                        id
                                                    )
                                                }}
                                            >
                                                <AddOutline color="white" />
                                            </Button>
                                        {/each}
                                    </span>
                                {/if}
                            </FormBoxContainer>
                        {/if}
                    {/each}
                {/if}
            </div>
            <div in:fly={{ y: 50, delay: 750 }} class="section">
                {#if Object.values(pndDocs).reduce((a, b) => a + b.length, 0) > 0}
                    <span>
                        <Typography type="h2" style="margin: 50px 0 11px 0"
                            >Documentación en Aprobación</Typography
                        >
                        <Typography
                            type="body"
                            style="margin: 2px 0 0 0"
                            color="grey-800"
                            >A continuación verá la documentación pendiente de
                            aprobación.</Typography
                        >
                    </span>
                    {#each Object.entries(pndDocs) as [category, docs]}
                        {#if docs.length > 0}
                            <FormBoxContainer
                                title={`${!['general', 'otros'].includes(category) ? 'Impuesto' : 'Documentación'} ${category}`}
                            >
                                {#each docs as { title, link, id }}
                                    <DocumentField
                                        preview
                                        {title}
                                        on:preview={(_) => {
                                            currentDocLink = link
                                            loadPDF()
                                            showDoc = true
                                        }}
                                        on:download={(_) => {
                                            window.open(link, '_blank')
                                        }}
                                    />
                                {/each}
                            </FormBoxContainer>
                        {/if}
                    {/each}
                {/if}
            </div>
        {:catch e}
            Error! {e}
        {/await}
    </div>
    <BackDrop
        style="position: fixed;z-index: var(--lvl-2); padding: 70px 0 0 0"
        visible={showDoc}
    >
        <span
            class="widget"
            use:clickOutside
            on:clickout={(_) => (showDoc = false)}
            transition:scale
        >
            {#await fetchDoc}
                <span
                    style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
                >
                    <Spinner />
                </span>
            {:then [bdata, typeMime]}
                <Typography style="position: relative"
                    >{currentTitleDoc}</Typography
                >
                <object
                    in:fade={{ delay: 250 }}
                    data={`data:${typeMime || 'application/pdf'};base64,${bdata}`}
                    title={currentDocConfig.title}
                    style="position: abosolute"
                ></object>
                <span
                    style="display: flex; flex-direction: row; gap: 8px; justify-content: flex-end"
                >
                    <Button
                        type="other"
                        label="Cerrar"
                        on:click={(_) => (showDoc = false)}
                    />
                    <Button
                        label="Descargar"
                        on:click={(_) => {
                            window.open(currentDocLink)
                            // window.location.href = "data:application/pdf;base64," + bdata;
                        }}
                    />
                </span>
            {:catch}
                <span
                    style="width: 450px; height: 250px; display: flex; flex-direction: column; align-items: center; gap: 16px;"
                >
                    <img src={otherinfo} draggable="false" alt="" />
                    <Typography style="text-align: center" type="h4">
                        Error al cargar el archivo: El archivo no existe o fue
                        borrado.
                    </Typography>
                    <Button
                        label="Cerrar"
                        on:click={(_) => (showDoc = false)}
                    />
                </span>
            {/await}
        </span>
    </BackDrop>

    <BackDrop
        style="position: fixed; padding: 70px 0 0 0"
        visible={showEditView}
    >
        {#key currentDocConfig}
            <Modal
                on:clickout={(_) => (showEditView = false)}
                on:close={(_) => (showEditView = false)}
                title="Actualización de documentos"
            >
                <!-- subtitle={`A continucion complete la informacion respecto a: ${currentDocConfig.impuesto === '' ? 'Documentación General' : currentDocConfig.impuesto }`} -->
                <Form bind:data={dataForm}>
                    <DocumentationField
                        name="docu_update"
                        {...currentDocConfig}
                        bind:valid={isValidDocForm}
                        optional={false}
                        required
                        multi={false}
                    />
                </Form>
                <span slot="buttonSet">
                    <Button
                        disabled={!isValidDocForm || blockSendButton}
                        on:click={sendData}
                        label="Enviar"
                    />
                </span>
            </Modal>
        {/key}
    </BackDrop>
    <div style="position: fixed; right: 15px; bottom: 15px; z-index: 2">
        <CircularButton
            title="Agregar documentación"
            on:click={(_) => {
                currentDocConfig = allConfigurations['otros.docu_otros_ii']
                showEditView = true
            }}
        />
    </div>
    <!-- <BackDrop /> -->
</div>

<style>
    object {
        position: relative;
        display: inline-block;
        width: 50vh;
        height: calc(1.485 * 50vh);
    }
    span.widget {
        padding: 10px;
        background-color: white;
        border-radius: 5px;
        box-shadow: var(--shadow-default);
        transition: all 0.5s ease-in-out;
        /* min-width: 50vh; */
        /* min-height: 50vh; */
    }
    .section {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }
</style>
